import { LocaleMap } from "tongues";
import { locales } from "./locales.js";

const config = {
	e: {
		form:     document.querySelector<HTMLFormElement>     ("#form-container")!,
		address:  document.querySelector<HTMLInputElement>    ("#form-input-address")!,
		count:    document.querySelector<HTMLInputElement>    ("#form-input-count")!,
		button:   document.querySelector<HTMLButtonElement>   ("#form-button")!,
		result:   document.querySelector<HTMLInputElement>    ("#form-result")!,
		networks: document.querySelector<HTMLDivElement>      ("#form-input-networks")!,
		dialog:   document.querySelector<HTMLDialogElement>   ("#form-input-networks-dialog")!,
		dropitem: document.querySelector<HTMLTemplateElement> ("#template-drop-item")!
	},
	placeholder: {
		bep20: "0x0000000000000000000000000000000000000000",
		trc20: "T000000000000000000000000000000000",
		eth20: "0x0000000000000000000000000000000000000000"
	} as Record<string, string>,
	copy: {
		timeout: 4200
	},
	selector: {
		options: {
			bep20: ["BEP20", "icons/bnb.svg"],
			trc20: ["TRC20", "icons/trx.svg"],
			eth20: ["ETH20", "icons/eth.svg"]
		} as Record<string, [caption: string, icon: string]>
	},
	urlTemplate: "https://example.com/transfer/{network}?to={address}&count={count}"
} as const;

const state = {
	currentLocale: "",
	t: null as null | LocaleMap,
	copyTimeout: null as null | number
}

main();

function main() {
	config.e.form.addEventListener("submit", submitHandler);

	lick();
	initChainDropdown();
	updateAddressPlaceholder();
	updateButtonStatus();
	updateChainSelector(config.e.networks.dataset.value!);

	config.e.address.addEventListener("input", updateButtonStatus);
	config.e.count.addEventListener("input", updateButtonStatus);
	config.e.networks.parentElement!.addEventListener("click", openChainDropdown);
	config.e.networks.addEventListener("keydown", handleDropdownKey)

	// config.e.result.parentElement!.addEventListener("click", () => config.e.result.select());
	config.e.button.addEventListener("click", submitHandler);
	config.e.dialog.addEventListener("click", closeChainDropdown);
}

function updateButtonStatus() {
	config.e.button.disabled = Boolean(inputsValid());
}
function inputsValid() {
	if (config.e.address.value.length === 0 ) return "address";
	if (config.e.count.value.length === 0 ) return "count";

	const countValue = parseFloat(config.e.count.value);
	if (isNaN(countValue)) return "count";
	if (countValue < 1 || countValue > 1000) return "count";

	return null;
}

function updateChainSelector(value: string) {
	config.e.networks.dataset.value = value
	const [caption, icon]= config.selector.options[value];
	config.e.networks.querySelector("img")!.src = icon;
	config.e.networks.querySelector("span")!.textContent = caption;
	updateAddressPlaceholder();
}

function submitHandler(e: Event) {
	e.preventDefault();

	if (inputsValid() !== null) return;

	const url = template();
	config.e.result.value = url;
	config.e.result.classList.remove("transparent");

	copy(url);
	if (state.copyTimeout !== null) clearTimeout(state.copyTimeout);
	relick(config.e.button, "button.copied");
	setTimeout(() => {
		relick(config.e.button, "button.copy");
	}, config.copy.timeout);
}

function updateAddressPlaceholder() {
	config.e.address.placeholder = config.placeholder[config.e.networks.dataset.value!] ?? "";
}

function copy(value: string) {
	const clipboardItemData = { ["text/plain"]: value };
	navigator.clipboard.write([new ClipboardItem(clipboardItemData)]);
}

function template() {
	return config.urlTemplate
		.replace("{network}", config.e.networks.dataset.value!)
		.replace("{address}", config.e.address.value)
		.replace(  "{count}", config.e.count.value);
}

function initChainDropdown() {
	const list = config.e.dialog.querySelector("div")!;
	const itemTemplate = config.e.dropitem;
	
	for (const [key, [caption, icon]] of Object.entries(config.selector.options)) {
		const newItem = itemTemplate.content.cloneNode(true)! as HTMLElement;
		const newE = newItem.querySelector("div")!;
		newE.addEventListener("click", () => updateChainSelector(key));
		newE.querySelector("img")!.src = icon;
		newE.querySelector("span")!.textContent = caption;
		list.appendChild(newItem);
	}
}
function handleDropdownKey(e: KeyboardEvent) {
	if (e.key === "Enter") {
		openChainDropdown();
		return;
	}
	if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
	const delta = e.key === "ArrowDown" ? 1 : -1;

	const options = Object.keys(config.selector.options);
	const currentKey = config.e.networks.dataset.value!;
	const currentIndex = options.findIndex(key => currentKey === key);

	let newIndex = currentIndex + delta;
	const lastIndex = options.length - 1;
	if (newIndex < 0) newIndex = lastIndex;
	if (newIndex >= options.length) newIndex = 0;

	updateChainSelector(options[newIndex])
}
function openChainDropdown() {
	const thumb = config.e.networks.getBoundingClientRect();
	const form = config.e.dialog.querySelector("form")!;
	form.style.top = `${thumb.bottom + 8}px`;
	form.style.left = `${thumb.left}px`;

	config.e.dialog.showModal();
}
function closeChainDropdown() {
	config.e.dialog.close();
}

function lick(locale?: string, firstPass: boolean = true) {
	const t = locale
		? locales.getMap(locale as ("en" | "ru"))
		: getBrowserLocale();
	state.currentLocale = t("name.short");
	state.t = t;
	const targets = document.querySelectorAll<HTMLElement>("[data-t]");
	for (const target of targets) {
		target.textContent = t(target.dataset.t!, "");
	}

	const selectors = document.querySelectorAll<HTMLElement>("[data-t-key]");
	for (const selector of selectors) {
		const key = selector.dataset.tKey!;
		console.log("lick call key", key)
		const active = key === state.currentLocale;
		selector.dataset.tActive = active ? "true" : "nope";
		if (firstPass) selector.addEventListener("click", () => lick(key, false));
	}
}
function relick(target: HTMLElement, key?: string) {
	if (key) target.dataset.t = key;
	if (!state.t) return;
	target.textContent = state.t(target.dataset.t!, "");
}

function getBrowserLocale() {
	const l = navigator.language ?? "en";
	if (l.startsWith("ru")) return locales.getMap("ru");
	return locales.getMap("en");
}
